import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
	fetchDeliveryAddressSuccess,
	fetchDeliveryAddressError,
	saveDeliveryAddressSuccess,
	saveDeliveryAddressError,
	setDeliveryAddress,
} from '../actions/delivery.js';
import { FETCH_DELIVERY_ADD, SAVE_DELIVERY_ADD } from '../actions/types';
import {
	fetchDeliveryAddress as fetchDeliveryAddressAPI,
	saveDeliveryAddress as saveDeliveryAddressAPI,
} from '../services/delivery';
import { showErrorMsg } from '../actions/snackbar';
import { validateSession } from './session';

function* fetchDeliveryAddress(action) {
	try {
		const { mobile, imei } = action.payload || {};
		const { sessionId } = yield select((state) => state.auth || {});
		const { data = [] } = yield call(validateSession, fetchDeliveryAddressAPI, mobile, imei, sessionId);
		yield put(fetchDeliveryAddressSuccess(data));
	} catch (error) {
		yield put(fetchDeliveryAddressError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* saveDeliveryAddress(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { index, address: updatedAddress } = action.payload;
		// yield delay(5000);
		const { id } = yield call(validateSession, saveDeliveryAddressAPI, action.payload, sessionId);
		let { address } = yield select((state) => state.delivery || {});
		address = address ? [...address] : [];
		const serverAddress = {
			...updatedAddress,
			id,
		};
		address[index] = serverAddress;

		yield put(saveDeliveryAddressSuccess(address));
		yield put(setDeliveryAddress(serverAddress));
	} catch (error) {
		yield put(saveDeliveryAddressError(error));
		yield put(showErrorMsg(error.message));
	}
}

export function* watchDelivery() {
	yield takeLatest(FETCH_DELIVERY_ADD, fetchDeliveryAddress);
	yield takeLatest(SAVE_DELIVERY_ADD, saveDeliveryAddress);
}
